"use client";

import ReactQueryProvider from "@/setup/react-query";
import { ToastProvider } from "@/context/ToastProvider";

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ReactQueryProvider>
      <ToastProvider>{children}</ToastProvider>
    </ReactQueryProvider>
  );
}
